module.exports = __webpack_public_path__ + "static/media/jardines03.76b651f6.jpg";